import { NotificaitonEmailTemplateModel } from './../../../misc/workflow/models/notification-email-template.model';
import { environment } from './../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificaitonEmailTemplateConfigModel } from '../models/notification-email-template.model';

@Injectable({
    providedIn: 'root'
})
export class EmailTemplateService {

    private notificationApi: string;

    constructor(private http: HttpClient) {
        this.notificationApi = environment.notificationUrl2;
    }

    getAllNotificationTemplateByModuleId(moduleId: number, channelId: number = 0, statusId: number = 0) {
        let params = new HttpParams()
            .append('moduleId', moduleId);

        if (channelId > 0) params = params.append('channelId', channelId)
        if (statusId > 0) params = params.append('status', statusId)

        return this.http.get<NotificaitonEmailTemplateConfigModel[]>(`${this.notificationApi}NotificationTemplate`, { params })
    }

    getEmailTemplateById(id: number, statusId: number): Observable<NotificaitonEmailTemplateConfigModel> {

        let params = new HttpParams()
            .append('status', statusId);

        return this.http.get<any>(`${this.notificationApi}NotificationTemplate/${id}`, { params });
    }


    addEmailTemplate(templateData: NotificaitonEmailTemplateConfigModel): Observable<any> {
        return this.http.post<any>(`${this.notificationApi}NotificationTemplate`, templateData);
    }

    updateEmailTemplate(templateData: NotificaitonEmailTemplateConfigModel): Observable<any> {
        return this.http.put<any>(`${this.notificationApi}NotificationTemplate/${templateData.id}`, templateData);
    }

    deleteEmailTemplate(templateId: number) {
        return this.http.delete<any>(`${this.notificationApi}NotificationTemplate/${templateId}`);
    }

    getAllTemplates(moduleId: number, channelId: number, pageNumber: number, pageSize: number, statusId: number, options?): Observable<any> {
        let url = `${this.notificationApi}NotificationTemplate/PagedList?ModuleId=${moduleId}&PageNumber=${pageNumber}&PageSize=${pageSize}`;

        if (statusId) {
            url = `${url}&status=${statusId}`;
        }

        if (channelId) {
            url = `${url}&channelId=${channelId}`;
        }

        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.filter && options.filter.field) {
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
            if (options.moduleSearchValue) {
                url = `${url}&ModuleSearchValue=${encodeURIComponent(options.moduleSearchValue)}`;
            }
        }

        // default sorting
        if (!options || !options.sort) {
            url = `${url}&SortBy=CreatedDate&IsAscending=false`;
        }

        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
    }

    validateEmailTemplate(templateName: string, statusId: number = 1): Observable<any> {
        return this.http.get<any>(`${this.notificationApi}NotificationTemplate/name?name=${templateName}&status=${statusId}`);
    }

    contentByReplacingTemplateFieldValue(templateId: number, objectReferenceId: number): Observable<any> {
        return this.http.get<any>(`${this.notificationApi}NotificationTemplate/ContentByReplacingTemplateFieldValue/${templateId}?objectReferenceId=${objectReferenceId}`);
    }

    emailNotificationTemplateListForDropDown(moduleId: number, channelId: number, status: number = 1): Observable<any> {
        return this.http.get<any>(`${this.notificationApi}NotificationTemplate/names?moduleId=${moduleId}&channelId=${channelId}&status=${status}`);
    }

    getEmailTemplates(moduleId: number, channelId: number, statusId: number = 1): Observable<NotificaitonEmailTemplateModel[]> {
        let params = new HttpParams()
        .set('moduleId', moduleId)
        .set('channelId', channelId)
        .set('status', statusId)

        return this.http.get<any>(`${this.notificationApi}NotificationTemplate`, { params });
    }
}
